import _Dialog from './dialog.jsx';
import extendVueInstall from '../utils/extend-vue-install';

import './style';

export const Dialog = extendVueInstall(_Dialog);
export { default as DialogPlugin } from './plugin.jsx';
export default Dialog;
